import React, { useRef } from 'react';
import ReactTooltip from 'react-tooltip';
import { TooltipContainer } from './styles';

interface TooltipProps {
  text?: string;
  place?: string;
  type?: 'dark' | 'success' | 'warning' | 'error' | 'info' | 'light';
}

const Tooltip: React.FC<TooltipProps> = ({
 children, place = 'right', text = '', type = 'light'
}) => {
  const tooltipRef = useRef<Element>(null);

  const showTooltip = () => {
    if (tooltipRef.current) {
      ReactTooltip.show(tooltipRef.current);
    }
  };

  const hideTooltip = () => {
    if (tooltipRef.current) {
      ReactTooltip.hide(tooltipRef.current);
    }
  };

  return (
    <TooltipContainer
      ref={tooltipRef}
      className="tooltip-container"
      data-class="custom-tooltip"
      data-tip={text}
      data-place={place}
      data-type={type}
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
    >
      {children}
    </TooltipContainer>
  );
};

export default Tooltip;
